import React from "react"
import { Outlet, useLocation } from "react-router-dom"
import Div100vh from "react-div-100vh"
import { Box, useTheme } from "@mui/material"
import clsx from "clsx"

import { useSponsoredFooterBanner } from "hooks/sponsored-content/useSponsoredFooterBanner"

import { IndoorMapContainer } from "containers/IndoorMapContainer"
import { SearchContainer } from "containers/SearchContainer"

import { IAppLayoutProps } from "layouts/interface"
import { AdMediaFooterCarousel } from "components/domains/ads"
import { SearchPopupContent } from "components/domains/search/kiosk-v/SearchPopupContent"
import { Header, HeaderLogo, HeaderTitle } from "components/Header"
import { Clock } from "components/Clock"
import { Footer } from "components/Footer"

const DEFAULT_SEARCH = <SearchContainer renderComponent={SearchPopupContent} />
const SPECIAL_TITLE = ["navigate", "dir", "place"]

export const AppLayout: React.FC<IAppLayoutProps> = ({
  search = DEFAULT_SEARCH,
  appNavigation = null,
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppLayout`]?.styleOverrides || {}
  const { footerBanners, footerBannerConfig } = useSponsoredFooterBanner()
  const { root, headerWrapper, contentWrapper, footerWrapper } = styleOverrides
  const location = useLocation()
  const pathName = location.pathname.split("/")
  const defaultTitle = pathName[1]?.split("-").join(" ")

  const specialTitle = SPECIAL_TITLE.find((title) => pathName.includes(title))
  const pageTitle = specialTitle ? specialTitle : defaultTitle

  return (
    <Div100vh data-name="AppLayout" style={root} className="AppLayout-root">
      <Box sx={headerWrapper} className={clsx("AppLayout-header", pageTitle)}>
        <Header
          logo={<HeaderLogo />}
          title={<HeaderTitle />}
          clock={<Clock />}
        />
      </Box>
      <Box sx={contentWrapper} className="AppLayout-content">
        <IndoorMapContainer />
        <Outlet />
        {search || DEFAULT_SEARCH}
        {appNavigation && appNavigation}
      </Box>
      <Box sx={footerWrapper} className="AppLayout-footer">
        <>
          {footerBanners.length > 0 ? (
            <AdMediaFooterCarousel
              data={footerBanners}
              carouselOptions={footerBannerConfig}
            />
          ) : (
            <Footer />
          )}
        </>
      </Box>
    </Div100vh>
  )
}
